/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GPD } from "./GPD";
import { GPDFromJSON, GPDFromJSONTyped, GPDToJSON, GPDToJSONTyped } from "./GPD";

/**
 *
 * @export
 * @interface ApiGpdGpdsList200Response
 */
export interface ApiGpdGpdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGpdGpdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGpdGpdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGpdGpdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GPD>}
   * @memberof ApiGpdGpdsList200Response
   */
  results: Array<GPD>;
}

/**
 * Check if a given object implements the ApiGpdGpdsList200Response interface.
 */
export function instanceOfApiGpdGpdsList200Response(
  value: object
): value is ApiGpdGpdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGpdGpdsList200ResponseFromJSON(json: any): ApiGpdGpdsList200Response {
  return ApiGpdGpdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGpdGpdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGpdGpdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GPDFromJSON),
  };
}

export function ApiGpdGpdsList200ResponseToJSON(json: any): ApiGpdGpdsList200Response {
  return ApiGpdGpdsList200ResponseToJSONTyped(json, false);
}

export function ApiGpdGpdsList200ResponseToJSONTyped(
  value?: ApiGpdGpdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GPDToJSON),
  };
}
